import { useEffect, useState } from "react";
import { Table, Button, Space, Checkbox, Select, Row, message, Typography } from "antd";
import type { TableColumnsType, TableProps } from "antd";
import StackInfoModal from "./StackInfoModal";
import {
  CombustionStackInfo,
  ResponseAPI,
  OptionFilterItem,
  FilterCombustion,
  dropdownOption,
  MasterData,
  Filter,
  EmissionTypeEnum,
  resetCombustion,
} from "src/entity/statck-info/stackInfo.entity";
import {
  getStackInfoCombustions,
  getStackInfoOptionFilterCombust,
  deleteStackInfoCombust,
  updateStackInfoCombust,
  createStackInfoCombust,
  getAreaMaster,
  getMasterData,
} from "src/services/combustion.service";

import { PlusCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import VocsModal from "src/components/Modal";
import { profileStore } from "src/stores/profile-store";
import { useShallow } from "zustand/react/shallow";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canEditTable, canViewTable } from "../../PermissionCheck/PermissionCheck";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import { componentPalette } from "src/theme/component-palette";
import { EmptyString } from "src/entity/common/unit.constant";
import { generateYearArray } from "src/utils/array";

const { Text } = Typography;

const SetupStackInfo = () => {
  const currentYear = new Date().getFullYear();
  const [companyId, setCompanyId] = useState<string>("");
  const profile = profileStore(useShallow((state) => state.profile));
  const [messageApi, contextHolder] = message.useMessage();
  const { permissions } = useNavigationMenu();
  const [data, setData] = useState<CombustionStackInfo[]>();
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const [showModalStackInfo, setShowModalStackInfo] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [mode, setMode] = useState<"insert" | "update">("insert");
  const [areaMaster, setAreaMaster] = useState<dropdownOption[]>([]);
  const [emissionMaster, setEmissionMaster] = useState<dropdownOption[]>([]);
  const [fuelTypeMaster, setFuelTypeMaster] = useState<dropdownOption[]>([]);
  const [filterStackId, setFilterStackId] = useState<number[]>();
  const [filterSourceId, setFilterSourceId] = useState<number[]>();
  const [filterArea, setFilterArea] = useState<Filter[]>();
  const [filterFuelName, setFilterFuelName] = useState<Filter[]>();
  const [filterFuelType, setFilterFuelType] = useState<Filter[]>();
  const [filterCalMethod, setFilterCalMethod] = useState<Filter[]>();
  const [filterCombustion, setFilterCombustion] = useState<FilterCombustion>({
    area: null,
    calculationMethod: null,
    fuelName: null,
    fuelType: null,
    sourceId: null,
    stackId: null,
  });
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const calculationMethods: dropdownOption[] = [
    { label: "Emission Factor", value: EmissionTypeEnum.EMISSION_FACTOR },
    { label: "Stack Sampling", value: EmissionTypeEnum.STACK_SAMPLING },
  ];

  const [initialData, setInitialData] = useState<CombustionStackInfo>({
    companyId: "",
    stackId: "",
    sourceId: "",
    area: "",
    fuelName: "",
    fuelType: "",
    calculationMethod: "",
    emission: {
      tvoc: false,
      bz: false,
      bd: false,
      vcm: false,
      edc: false,
    },
    year: "",
  });

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const showDeleteConfirm = (value: CombustionStackInfo) => {
    const { _id } = value;
    VocsModal.delete({
      onOk: () => {
        if (_id) {
          handleDeleteCombustion(_id);
        }
      },
    });
  };

  const createParamFilter = () => {
    let queryParam = "";
    let offset = 0;
    let limit = pageSize;
    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }
    if (current) {
      let resultCalOffset = calPagination(current);
      if (resultCalOffset) {
        offset = resultCalOffset;
      }
      queryParam += `&offset=${offset}`;
    }
    if (limit) {
      queryParam += `&limit=${limit}`;
    }
    if (filterCombustion) {
      const str = Object.entries(filterCombustion)
        .filter(([_, value]) => value != null && value.length > 0)
        .map(([key, value]) => `&${key}=[${[value.join(",")]}]`)
        .join("");
      queryParam += str;
    }

    return queryParam;
  };

  const fetchCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let offset = 0;
        let resultCalOffset = calPagination(current);
        if (resultCalOffset) {
          offset = resultCalOffset;
        }
        const queryParam = createParamFilter();
        let response = await getStackInfoCombustions(companyId, queryParam);
        let responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          setLoading(false);
          // let combustions = responseData.data.combustions.map((el, index) => {
          //   return {
          //     no: (index + offset + 1).toString(),
          //     ...el,
          //   };
          // });
          setData([...responseData?.data?.combustions]);
          setTotal(responseData?.data?.total);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAreaMaster = async () => {
    try {
      if (companyId) {
        setLoading(true);
        const response = await getAreaMaster(companyId);
        if (response.data.code === 200) {
          setLoading(false);
          const area = response.data.data;
          const areaMaster = area.map((item: any) => {
            return {
              label: item.areaName,
              value: item.areaValue,
            };
          });
          setAreaMaster(areaMaster);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchMasterData = async () => {
    try {
      const response = await getMasterData();
      if (response.data.code === 200) {
        const master: MasterData[] = response.data.data;

        if (master.length > 0) {
          let optionEmission = master.find((el) => el.label === "Emission");
          if (optionEmission && optionEmission?.options) {
            setEmissionMaster(optionEmission?.options);
          }

          let optionFuelType = master.find((el) => el.label === "Fuel Type");
          if (optionFuelType && optionFuelType?.options) {
            setFuelTypeMaster(optionFuelType?.options);
          }
        } else {
          setEmissionMaster([]);
          setFuelTypeMaster([]);
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const calPagination = (current?: number) => {
    if (current) {
      return (current - 1) * 10;
    }
  };

  const fetchOptionFilterCombustions = async () => {
    try {
      if (companyId) {
        setLoading(true);
        let query = `year=${selectedYear}`;
        let response = await getStackInfoOptionFilterCombust(companyId, query);
        let responseData: ResponseAPI = response.data;
        if (responseData.code === 200) {
          const filter = response.data.data.filter;

          if (filter.length > 0) {
            setFilterStackId(filter.find((item: OptionFilterItem) => item.key === "stackId")?.filter ?? []);
            setFilterSourceId(filter.find((item: OptionFilterItem) => item.key === "sourceId")?.filter ?? []);

            const filterArea = filter.find((item: OptionFilterItem) => item.key === "area")?.filter;
            if (areaMaster && filterArea) {
              const optionArea = filterArea.map((el: any) => {
                const resultMap = areaMaster.find((item) => item.value === el);
                return {
                  text: resultMap?.label,
                  value: resultMap?.value,
                };
              });
              setFilterArea(optionArea);
            }

            const filterFuelType = filter.find((item: OptionFilterItem) => item.key === "fuelType")?.filter;
            if (filterFuelType && fuelTypeMaster) {
              const optionFuelType = filterFuelType.map((el: any) => {
                const resultMap = fuelTypeMaster.find((item) => item.value === el);
                return {
                  text: el == EmptyString ? "" : resultMap?.label,
                  value: resultMap?.value ?? el,
                };
              });
              setFilterFuelType(optionFuelType);
            }

            const filterFuelName = filter.find((item: OptionFilterItem) => item.key === "fuelName")?.filter;
            if (filterFuelName) {
              const optionFuelName = filterFuelName.map((el: string | null) => ({
                text: el === EmptyString ? "" : el || "",
                value: el || "",
              }));

              setFilterFuelName(optionFuelName);
            }

            const filterCalMet = filter.find((item: OptionFilterItem) => item.key === "calculationMethod")?.filter;
            if (filterCalMet && calculationMethods) {
              const optionCalMet = filterCalMet.map((el: any) => {
                const resultMap = calculationMethods.find((item) => item.value === el);
                return {
                  text: resultMap?.label,
                  value: resultMap?.value,
                };
              });
              setFilterCalMethod(optionCalMet);
            }
          } else {
            setFilterStackId([]);
            setFilterSourceId([]);
            setFilterArea([]);
            setFilterFuelName([]);
            setFilterCalMethod([]);
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleDeleteCombustion = async (id: string) => {
    try {
      if (companyId) {
        setLoading(true);
        let responseAPI = await deleteStackInfoCombust(companyId, id);
        let responseDelete: ResponseAPI = responseAPI.data;
        let isSelectYear = true;

        if (responseDelete.code === 200) {
          setLoading(false);
          messageApi.open({
            type: "success",
            content: CommonSuccess.DELETE_SUCCESSFULL,
          });
          fetchCombustions();
          fetchOptionFilterCombustions();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCombustion = async (data: CombustionStackInfo) => {
    try {
      if (companyId) {
        let id = data._id;
        data.companyId = companyId;

        if (selectedYear) {
          data.year = selectedYear;
        }

        setLoading(true);

        let response;
        if (mode === "update" && id) {
          response = await await updateStackInfoCombust(companyId, id, data);
        } else {
          response = await await createStackInfoCombust(data);
        }

        const responseData: ResponseAPI = response.data;

        if (responseData.code === 200) {
          messageApi.open({
            type: "success",
            content: CommonSuccess.SAVED_SUCCESSFULL,
          });
          fetchCombustions();
          fetchOptionFilterCombustions();
          setShowModalStackInfo(false);
          setIsDuplicate(false);
        } else {
          setShowModalStackInfo(false);
          setIsDuplicate(false);
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error?.response?.status === 409) {
          setIsDuplicate(true);
        } else {
          setIsDuplicate(false);
          messageApi.open({
            type: "error",
            content: CommonError.SOMETHING_WRONG,
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModalStackInfo = (mode: "insert" | "update", combustion: CombustionStackInfo) => {
    setInitialData(combustion);
    setMode(mode);
    setShowModalStackInfo(true);
  };

  const intitalData = () => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  };

  const resetFilter = () => {
    setFilterCombustion({});
  };

  useEffect(() => {
    intitalData();
    fetchYear();
  }, []);

  useEffect(() => {
    intitalData();
  }, [profile?.activeCompany]);

  useEffect(() => {
    setSelectedYear(currentYear);
    setCurrent(1);
    fetchAreaMaster();
    fetchMasterData();
    resetFilter();
    setCurrent(1);
  }, [companyId]);

  useEffect(() => {
    resetFilter();
    setCurrent(1);
  }, [selectedYear]);

  useEffect(() => {
    fetchOptionFilterCombustions();
  }, [areaMaster, fuelTypeMaster, emissionMaster, selectedYear]);

  useEffect(() => {
    if (selectedYear) {
      fetchCombustions();
    }
  }, [current, filterCombustion]);

  const columns: TableColumnsType<CombustionStackInfo> = [
    {
      title: "Stack ID",
      dataIndex: "stackId",
      align: "center",
      defaultSortOrder: "descend",
      filteredValue: filterCombustion?.stackId || null,
      filters: filterStackId?.map((el: number) => ({ text: el, value: el })),
      width: 120,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Source ID",
      dataIndex: "sourceId",
      align: "center",
      defaultSortOrder: "descend",
      filteredValue: filterCombustion?.sourceId || null,
      filters: filterSourceId?.map((el: number) => ({ text: el, value: el })),
      width: 120,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Area",
      dataIndex: "area",
      align: "center",
      filteredValue: filterCombustion?.area || null,
      filters: filterArea,
      width: 80,
      render: (value: string) => {
        const area = areaMaster.find((el) => el.value === value);
        return area ? <Text>{area.label}</Text> : null;
      },
    },
    {
      title: "Calculation Method",
      dataIndex: "calculationMethod",
      align: "center",
      width: 200,
      filters: filterCalMethod,
      filteredValue: filterCombustion?.calculationMethod || null,
      render: (value: string) => {
        const calMet = calculationMethods.find((el) => el.value === value);
        return calMet ? <Text>{calMet.label}</Text> : null;
      },
    },
    {
      title: "Fuel Name",
      dataIndex: "fuelName",
      align: "center",
      width: 150,
      filteredValue: filterCombustion?.fuelName || null,
      filters: filterFuelName,

      render: (text) => <Text>{text}</Text>,
    },
    // {
    //   title: "Fuel Type",
    //   dataIndex: "fuelType",
    //   width: 150,
    //   filters: filterFuelType,
    //   filteredValue: filterCombustion?.fuelType || null,

    //   render: (value: string) => {
    //     const fuelTypeVal = fuelTypeMaster.find((el) => el.value === value);
    //     return fuelTypeVal ? <Text>{fuelTypeVal.label}</Text> : null;
    //   },
    // },
    // {
    //   title: "Emission",
    //   align: "center",
    //   children: emissionMaster.map((item) => ({
    //     title: item.label,
    //     dataIndex: "emission",
    //     width: "6%",
    //     render: (value) => (
    //       <div>
    //         <Checkbox checked={value[item.value]} disabled={true}></Checkbox>
    //       </div>
    //     ),
    //   })),
    // },
    {
      title: "Action",
      dataIndex: "",
      align: "center",
      key: "action",
      render: (value, record) => (
        <Space>
          <Button
            className="border-transparent bg-transparent"
            size={"small"}
            disabled={!canEditTable(permissions)}
            onClick={() => {
              handleOpenModalStackInfo("update", record);
            }}
          >
            <BsPencilSquare size={18} color={componentPalette.blueGrey} />
          </Button>
          <Button
            className="border-transparent bg-transparent"
            disabled={!canEditTable(permissions) || record.isFlowActive}
            onClick={() => showDeleteConfirm(value)}
          >
            <BsTrashFill size={18} color={componentPalette.blueGrey} />
          </Button>
        </Space>
      ),
    },
  ];

  const onTableChange: TableProps<CombustionStackInfo>["onChange"] = (pagination: any, filters: any) => {
    setFilterCombustion((prevState) => ({
      ...prevState,
      ...filters,
    }));
    setCurrent(pagination.current);
    setPageSize(pagination.pageSize);
  };

  return (
    <div>
      {contextHolder}
      {showModalStackInfo && (
        <StackInfoModal
          open={showModalStackInfo}
          mode={mode}
          initialData={initialData}
          areaMaster={areaMaster}
          emissionMaster={emissionMaster}
          fuelTypeMaster={fuelTypeMaster}
          isDuplicate={isDuplicate}
          loading={loading}
          onChangeData={(isDupChange) => {
            setIsDuplicate(isDupChange);
          }}
          onCancelStackInfo={() => {
            setIsDuplicate(false);
            setShowModalStackInfo(false);
          }}
          onSaveStackInfo={(data) => {
            handleSaveCombustion(data);
          }}
        />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "10px" }}>
        <Select
          value={selectedYear}
          style={{ width: 120 }}
          onChange={handleYearChange}
          options={optionYears.map((year) => ({ label: year, value: year }))}
          loading={loading}
          size="middle"
        />
        <Button
          type="primary"
          size="middle"
          onClick={() => handleOpenModalStackInfo("insert", resetCombustion)}
          style={{
            display: "flex",
            alignItems: "center",
            visibility: canEditTable(permissions) ? "visible" : "hidden",
          }}
          loading={loading}
        >
          <PlusCircleOutlined />
          New
        </Button>
      </div>
      <Row className="w-full" id={"wrap-stackinfo-config-table"}>
        <Table
          className="w-full whitespace-nowrap"
          columns={columns}
          dataSource={canViewTable(permissions) ? data : []}
          onChange={onTableChange}
          rowKey="_id"
          scroll={{ x: "max-content" }}
          loading={loading}
          pagination={{
            size: "small",
            showSizeChanger: false,
            current,
            pageSize,
            total,
          }}
        />
      </Row>
    </div>
  );
};

export default SetupStackInfo;
